export default __webpack_public_path__ + "static/media/arrow_right.ed061540.svg";